// extracted by mini-css-extract-plugin
module.exports = {"social":"_2pgbUW"};